import { workflowManagerApi } from "./workflow-api"

interface RenameWorkflowVersionParams {
  workflowId: string
  wfRunId: string
  body: any
}

export const handleRenameWorkflowVersion = async (
  { workflowId, wfRunId, body }: RenameWorkflowVersionParams,
  { dispatch, queryFulfilled }: { dispatch: any; queryFulfilled: Promise<any> }
) => {
  const patchResult = dispatch(
    workflowManagerApi.util.updateQueryData(
      "getWorkflowVersions",
      { workflowId },
      (draft) => {
        const version = draft.response.data?.runs.find(
          (v) => v.id === wfRunId
        )
        if (version) {
          version.description = body.description
        }
      }
    )
  )
  try {
    await queryFulfilled
  } catch {
    patchResult.undo()
  }
}
